import { NgClass } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { Button, Icon } from '@gruposaltaedu/liv-design-system/components';
import { TranslatePipe } from '@ngx-translate/core';

import { EmptyStateVariant } from './empty-state-variant.type';

const DEFAULT_ICONS: Record<EmptyStateVariant, string> = {
  empty: 'heroMagnifyingGlass',
  failure: 'heroExclamationTriangle'
};

@Component({
  selector: 'liv-empty-state',
  imports: [Icon, Button, TranslatePipe, NgClass],
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.scss'
})
export class EmptyStateComponent {
  readonly variant = input<EmptyStateVariant>('empty');
  readonly title = input<string>();
  readonly description = input<string>();
  readonly icon = input<string>();
  readonly showIcon = input(true);
  readonly showRetry = input(true);
  readonly retryLabel = input<string>();

  readonly retry = output<void>();

  readonly resolvedIcon = computed(
    () => this.icon() ?? DEFAULT_ICONS[this.variant()]
  );

  readonly isFailure = computed(() => this.variant() === 'failure');

  onRetry(): void {
    this.retry.emit();
  }
}
